import { useMediaQuery } from '@eltoro-ui/hooks'
import { CreativeEditOLTableOrderLineRow } from './CreativeEditOLTableOrderLineRow'
import { ModifiedOrderLineType } from '../types'
import { Creativeservicev1Creative } from 'next-gen-sdk'

export type CreativeEditOLTableProps = {
  modifiedOrderLines: ModifiedOrderLineType[]
  handleUpdateClickThru: (
    clickThroughUrl: string,
    modifiedOL: ModifiedOrderLineType,
  ) => void
  handleRemoveCreative: (
    orderLine: ModifiedOrderLineType,
    creative?: Creativeservicev1Creative,
  ) => void
  handleUpdateBrandURL?: (
    brandUrls: string[],
    modifiedOL: ModifiedOrderLineType,
  ) => void
  handleRemoveBrandURL?: (orderLine: ModifiedOrderLineType) => void
}

export const CreativeEditOLTable = ({
  modifiedOrderLines,
  handleRemoveCreative,
  handleUpdateClickThru,
  handleUpdateBrandURL,
  handleRemoveBrandURL,
}: CreativeEditOLTableProps) => {
  const [isTablet] = useMediaQuery('(max-width: 1023px)')

  return (
    <div className="EditOLTable w-full">
      <div className="EditOLTable__body">
        {modifiedOrderLines.map((orderLine, index) => (
          <CreativeEditOLTableOrderLineRow
            key={`CreativeEditOLTableOrderLineRow_${
              orderLine.id || orderLine.tempId
            }_${index}`}
            orderLine={orderLine}
            handleUpdateClickThru={handleUpdateClickThru}
            handleRemoveCreative={handleRemoveCreative}
            handleUpdateBrandURL={handleUpdateBrandURL}
            handleRemoveBrandURL={handleRemoveBrandURL}
            isTablet={isTablet}
          />
        ))}
      </div>
    </div>
  )
}
